import { useEffect, useState } from "react";
import { Col, Modal, Row, Button, notification, Table } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { CheckCircleOutlined, CloseCircleOutlined, LinkOutlined } from "@ant-design/icons";

import mbImage from "../../../../assets/icons/MB.svg";
import mbWayImage from "../../../../assets/icons/MB-Way.svg";
import bankImage from "../../../../assets/icons/Bank.svg";
import endpoints from "../../../../utils/endoinpts";
import "./Update.css";
import ModalCancelDebit from "../../../UserComponents/ModalCancelDebit/ModalCancelDebit";

const columns = [
  {
    title: "Data",
    dataIndex: "date",
    key: "date",
    width: 120,
  },
  {
    title: "Método",
    dataIndex: "payment_method",
    key: "payment_method",
  },
  {
    title: "Desrição",
    dataIndex: "invoice_item_description",
    key: "invoice_item_description",
  },
  {
    title: "Valor",
    dataIndex: "value",
    key: "value",
  },
  {
    title: "Tipo",
    dataIndex: "payment_plan_type",
    key: "payment_plan_type",
  },
  {
    title: "Data de pagamento",
    dataIndex: "payment_date",
    key: "payment_date",
    width: 120,
  },
  {
    title: "Expira",
    dataIndex: "payment_valid_date",
    key: "payment_valid_date",
    width: 120,
  },
  {
    title: "Estado",
    dataIndex: "statusHTML",
    key: "statusHTML",
    width: 300,
  },
  {
    title: "Fatura",
    dataIndex: "invoice_link",
    key: "invoice_link",
  },
  {
    title: "",
    dataIndex: "edit_payment",
    key: "edit_payment",
    width: 140,
  },
];

export default function PaymentData({ admin, activeKey, user_id }) {
  const [paymentData, setPaymentData] = useState([]);
  const [prices, setPrices] = useState([]);
  const [user, setUser] = useState({});
  const [tableData, setTableData] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isOpenModalPay, setIsOpenModalPay] = useState(false);
  const [isOpenModalCancelPay, setIsOpenModalCancelPay] = useState(false);
  const [isOpenModalCancelDebit, setIsOpenModalCancelDebit] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [selectedPaymentData, setSelectedPaymentData] = useState({});

  const expandedRowRender = (e) => {
    console.log(e);
    const columnsExpanded =
      e.full_data.method === "mb"
        ? [
            {
              title: "Entidade",
              dataIndex: "entity",
              key: "entity",
            },
            {
              title: "Referência",
              dataIndex: "reference",
              key: "reference",
            },
            {
              title: "Valor",
              dataIndex: "value",
              key: "value",
            },
            {
              title: "ID Pagamento",
              dataIndex: "id_payment",
              key: "id_payment",
            },
          ]
        : e.full_data.method === "mbway"
          ? [
              {
                title: "N. Telemóvel",
                dataIndex: "phone",
                key: "phone",
              },
              {
                title: "Valor",
                dataIndex: "value",
                key: "value",
              },
              {
                title: "ID Pagamento",
                dataIndex: "id_payment",
                key: "id_payment",
              },
            ]
          : [
              {
                title: "Banco",
                dataIndex: "bank_name",
                key: "bank_name",
              },
              {
                title: "IBAN",
                dataIndex: "iban",
                key: "iban",
              },
              {
                title: "Valor",
                dataIndex: "value",
                key: "value",
              },
              {
                title: "ID Pagamento",
                dataIndex: "id_payment",
                key: "id_payment",
              },
            ];

    const dataExpanded =
      e.full_data.method === "mb"
        ? [
            {
              reference: e.full_data.reference,
              entity: e.full_data.entity,
              value: e.full_data.value + "€",
              id_payment: e.full_data.payment_id,
            },
          ]
        : e.full_data.method === "mbway"
          ? [
              {
                phone: e.full_data.phone_number,
                value: e.full_data.value + "€",
                id_payment: e.full_data.payment_id,
              },
            ]
          : [
              {
                bank_name: e.full_data.bank_name,
                iban: e.full_data.iban,
                value: e.full_data.value + "€",
                id_payment: e.full_data.payment_id,
              },
            ];
    return <Table className="expanded_table" columns={columnsExpanded} dataSource={dataExpanded} pagination={false} />;
  };

  useEffect(() => {
    if (user_id && activeKey === 2) {
      handleGetUserPaymentData();
    }
  }, [activeKey, user_id]);

  function handleGetUserPaymentData() {
    setIsTableLoading(true);
    axios
      .get(endpoints.purchase.getPurchases, {
        params: { id_user: user_id },
      })
      .then((res) => {
        let paymentServerData = res.data[0];
        setUser(res.data[1][0]);
        handleGetPrices(res.data[1][0]);
        let aux = [];
        for (let i = 0; i < paymentServerData.length; i++) {
          let invoice_items_json = paymentServerData[i].invoice_items ? JSON.parse(paymentServerData[i].invoice_items) : null;

          let next_payment_date = null;
          let daysAccess = null;
          if (paymentServerData[i].method === "debit") {
            next_payment_date = dayjs(paymentServerData[i].date);
            let today = dayjs().subtract(3, "day");
            daysAccess = today.diff(next_payment_date, "day");
          }

          let auxObject = {
            key: "payment_id_" + paymentServerData[i].id,
            date: dayjs(paymentServerData[i].date).format("DD-MM-YYYY"),
            payment_method: (
              <div className="payment_method">
                <img src={paymentServerData[i].method === "mb" ? mbImage : paymentServerData[i].method === "mbway" ? mbWayImage : bankImage} />
              </div>
            ),
            payment_date: paymentServerData[i].payment_date ? dayjs(paymentServerData[i].payment_date).format("YYYY-MM-DD") : "-",
            payment_valid_date: paymentServerData[i].payment_valid_date ? dayjs(paymentServerData[i].payment_valid_date).format("YYYY-MM-DD") : "-",
            statusHTML: (
              <div
                className={`status ${
                  paymentServerData[i].status === "pago"
                    ? "pago"
                    : paymentServerData[i].status === "cancelado" || paymentServerData[i].status === "expirado"
                      ? "cancelado"
                      : "processing"
                }`}
              >
                {paymentServerData[i].status}
              </div>
            ),
            value: paymentServerData[i].value + "€",
            payment_plan_type: paymentServerData[i].payment_plan_type,
            invoice_item_description: invoice_items_json ? invoice_items_json[0].description : "-",
            invoice_link: paymentServerData[i].invoice_link ? (
              <Button target="_blank" href={paymentServerData[i].invoice_link}>
                <LinkOutlined />
              </Button>
            ) : (
              "-"
            ),
            description: paymentServerData[i].description,
            edit_payment: !admin.is_viewer ? (
              <Button
                danger
                type="primary"
                disabled={paymentServerData[i].status === "pago" || paymentServerData[i].status === "cancelado" || paymentServerData[i].status === "expirado"}
                onClick={() => handleOpenModalCancelPay(paymentServerData[i])}
              >
                <CloseCircleOutlined />
              </Button>
            ) : null,
            full_data: paymentServerData[i],
          };
          aux.push(auxObject);
        }
        setPaymentData(paymentServerData);
        setTableData(aux);
        setIsTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleUserPay() {
    setIsTableLoading(true);
    setIsButtonLoading(true);
    axios
      .post(endpoints.purchase.verifyPurchaseDebitManual, {
        data: selectedPaymentData,
      })
      .then((res) => {
        if (res.data.errors) {
          let message = "";
          let errors = res.data.errors;
          for (let i = 0; i < errors.length; i++) {
            if (i === errors.length - 1) {
              message += errors[i].error;
            } else {
              message += errors[i].error + ", ";
            }
          }

          notification.error({
            message: "Erro",
            description: `Aconteceram os seguintes erros: "${message}". Verifique se a informação está toda correta `,
            placement: "top",
          });
          setIsOpenModalPay(false);
          setIsTableLoading(false);
          setIsButtonLoading(false);
        } else {
          setIsOpenModalPay(false);
          handleGetUserPaymentData();
          setIsTableLoading(false);
          setIsButtonLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleUserCancelPay() {
    setIsTableLoading(true);
    axios
      .post(endpoints.purchase.paymentUserCancel, {
        data: selectedPaymentData,
      })
      .then((res) => {
        setIsOpenModalCancelPay(false);
        handleGetUserPaymentData();
        setIsTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleOpenModalPay(data) {
    setSelectedPaymentData(data);
    setIsOpenModalPay(true);
  }

  function handleGetPrices(auxUser) {
    axios
      .get(endpoints.purchase.getPrices)
      .then((res) => {
        let auxPrices = res.data.filter((value, index) => value.id_profession === auxUser.id_profession && value.retiree === auxUser.retiree);
        setPrices(auxPrices);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleOpenModalCancelPay(data) {
    setSelectedPaymentData(data);

    if (data.method === "debit") {
      setIsOpenModalCancelDebit(true);
    } else {
      setIsOpenModalCancelPay(true);
    }
  }

  function handleCloseModalCancelDebit() {
    setIsOpenModalCancelDebit(false);
    setSelectedPaymentData({});
    handleGetUserPaymentData();
  }

  function handleSubmitMB(values) {
    setIsButtonLoading(true);
    handleGenerateMB()
      .then((res) => {
        handleSubmitNewPayment(res).then((result) => {
          setIsTableLoading(true);
          setTimeout(() => {
            notification.success({
              message: `Sucesso`,
              description: "A RM foi gerada com sucesso",
            });
            setIsTableLoading(false);
            setIsButtonLoading(false);
            handleGetUserPaymentData();
          }, 2000);
        });
      })
      .catch((err) => {
        setIsButtonLoading(false);
        console.log(err);
        notification.error({
          message: `Erro`,
          description: "Aconteceu alguma coisa de errado, por favor tente novamente!",
        });
      });
  }

  function handleSubmitNewPayment(res) {
    return new Promise((resolve, reject) => {
      let priceFiltered = JSON.parse(JSON.stringify(prices)).filter(
        (value) => Number(value.id_payment_plan) === 1 && value.type === "mb" && value.id_profession === user.id_profession && value.retiree === user.retiree,
      )[0];

      let userId = user.id;

      do {
        userId = `0${userId}`;
      } while (userId.length < 4);

      let order_id = `${dayjs().format("YYYYMMDD")}${userId}`;
      let invoice_item_quantity = 1;

      if (user.valid_access_date) {
        let valid_access_date = dayjs(user.valid_access_date);
        let today = dayjs();
        let yearsAccess = today.diff(valid_access_date, "y");

        if (yearsAccess >= 1) {
          invoice_item_quantity = 2;
        }

        if (Object.keys(priceFiltered).length > 0 && yearsAccess >= 1) {
          priceFiltered.price = Number(priceFiltered.price) * 2;
        }
      }

      let invoice_items = [
        {
          code: priceFiltered.invoice_item_code,
          description: priceFiltered.invoice_item_description,
          price: priceFiltered.price,
          quantity: invoice_item_quantity,
          discount: 0,
          unit: "unit",
        },
      ];

      let auxData = {
        id_user: user.id,
        id_payment_plan: priceFiltered.id_payment_plan,
        date: dayjs().format("YYYY-MM-DD"),
        type: "quotes",
        method: "mb",
        entity: res.Entity,
        reference: res.Reference,
        iban: null,
        bank_name: null,
        bank_user_name: null,
        phone_number: null,
        value: priceFiltered.price,
        process_id: order_id,
        payment_id: res.RequestId,
        payment_expiry_date: res.ExpiryDate,
        status: "em validação",
        invoice_items: JSON.stringify(invoice_items),
      };

      axios
        .post(endpoints.purchase.postPurchase, {
          data: {
            userData: {
              ...user,
              profession_name: priceFiltered.profession_name,
            },
            paymentData: auxData,
            type: "user",
            voucherData: null,
          },
        })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }

  function handleGenerateMB() {
    return new Promise((resolve, reject) => {
      let userId = user.id;

      do {
        userId = `0${userId}`;
      } while (userId.length < 4);

      let order_id = `${dayjs().format("YYYYMMDD")}${userId}`;

      let today = dayjs();
      let validAccessDate = dayjs(user.valid_access_date);
      let nextValidAcessDate = dayjs(user.valid_access_date).add("1", "y");
      let expiryDays = nextValidAcessDate.diff(today, "d");

      let yearsAccess = today.diff(validAccessDate, "y");

      let priceFiltered = JSON.parse(JSON.stringify(prices)).filter(
        (value) => Number(value.id_payment_plan) === 1 && value.type === "mb" && value.id_profession === user.id_profession && value.retiree === user.retiree,
      )[0];

      if (Object.keys(priceFiltered).length > 0 && yearsAccess >= 1) {
        priceFiltered.price = Number(priceFiltered.price) * 2;
      }

      let data = {
        type: "quotes",
        planId: 1,
        userId: user.id,
        orderId: order_id,
        amount: priceFiltered.price,
        description: priceFiltered.invoice_item_description,
        clientName: user.name,
        clientEmail: user.email,
        expiryDays: yearsAccess >= 1 ? "730" : expiryDays.toString(),
      };

      axios
        .post(endpoints.purchase.purchaseMB, {
          data: data,
        })
        .then((res) => {
          console.log(res.data);
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }

  return (
    <>
      <ModalCancelDebit user={user} open={isOpenModalCancelDebit} close={handleCloseModalCancelDebit} />
      {paymentData && paymentData.length > 0 && paymentData[0].status !== "em validação" && paymentData[0].status !== "próximo pagamento" && user?.payment_valid === 0 ? (
        <Row className="flex justify-end items-end w-full">
          <Button loading={isButtonLoading} onClick={handleSubmitMB}>
            Gerar RM
          </Button>
        </Row>
      ) : !paymentData || paymentData.length === 0 ? (
        <Row className="flex justify-end items-end w-full">
          <Button loading={isButtonLoading} onClick={handleSubmitMB}>
            Gerar RM
          </Button>
        </Row>
      ) : null}
      <Row className="edit_profile_content drawer">
        <Col span={24}>
          <Table columns={columns} dataSource={tableData} loading={isTableLoading} expandable={{ expandedRowRender }} />
        </Col>
      </Row>
      <Modal
        className="user-payment-modal"
        open={isOpenModalPay}
        onCancel={() => setIsOpenModalPay(false)}
        title="Validar pagamento"
        footer={[
          <Button className="payment_button" key="submit" type="primary" onClick={handleUserPay} loading={isButtonLoading}>
            Sim
          </Button>,
          <Button className="payment_button back" key="submit" type="primary" onClick={() => setIsOpenModalPay(false)}>
            Não
          </Button>,
        ]}
        maskClosable={false}
      >
        <Row>
          <Col span={24}>Tem a certeza que deseja validar este pagamento?</Col>
        </Row>
      </Modal>

      <Modal
        className="user-payment-modal"
        open={isOpenModalCancelPay}
        onCancel={() => setIsOpenModalCancelPay(false)}
        title="Cancelar pagamento"
        footer={[
          <Button className="payment_button" key="submit" type="primary" onClick={handleUserCancelPay}>
            Sim
          </Button>,
          <Button className="payment_button back" key="submit" type="primary" onClick={() => setIsOpenModalCancelPay(false)}>
            Não
          </Button>,
        ]}
        maskClosable={false}
      >
        <Row>
          <Col span={24}>Tem a certeza que deseja cancelar este pagamento?</Col>
        </Row>
      </Modal>
    </>
  );
}
